export const ACCOUNT_TYPE_OPTIONS = [
    { value: "default", label: "Default" },
    { value: "admin", label: "Admin" },
    { value: "csm", label: "CSM" },
    { value: "developer", label: "Developer" },
    { value: "Engineer", label: "Engineer" },
    { value: "QA", label: "QA" },
    { value: "Designer", label: "Designer" }
];

export const ENVIRONMENT_OPTIONS = [
    { id: "dev", label: "Development" },
    { id: "staging", label: "Staging" },
    { id: "demo", label: "Demo" },
    { id: "sandbox", label: "Sandbox" },
    { id: "production", label: "Production" }
];

export const ROLE_OPTIONS = [
    { id: "logan-default-user", label: "Logan Default User" },
    { id: "logan-admin", label: "Logan Admin" },
    { id: "engineering", label: "Engineering" },
    { id: "csm", label: "CSM" },
    { id: "notifications-admin", label: "Notifications Admin" },
    { id: "marketing", label: "Marketing" }
];

export const DEFAULT_FORM_VALUES = {
    displayName: "",
    email: "",
    accountType: "",
    environments: [],
    roles: []
};